export default __webpack_public_path__ + "static/media/like.f449b91e.svg";